import React from 'react';

const SvgUserAdd = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 16 16" ref={svgRef} {...{ ...{ width: '1em', height: '1em' }, ...props }}>
    <title>{title}</title>
    <path
      fill="currentColor"
      d="M14.998 4.667h-1.667V3a.333.333 0 0 0-.333-.333h-.667a.333.333 0 0 0-.333.333v1.667h-1.667A.333.333 0 0 0 9.998 5v.667c0 .184.15.333.333.333h1.667v1.667c0 .184.15.333.333.333h.667c.184 0 .333-.15.333-.333V6h1.667c.184 0 .333-.15.333-.333V5a.333.333 0 0 0-.333-.333zM5.998 6a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333zm4.3 2.44a2 2 0 0 0-1.793-1.107H3.49A2 2 0 0 0 1.698 8.44l-.96 1.927a.667.667 0 0 0 .593.966h9.334a.667.667 0 0 0 .593-.966z"
    />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgUserAdd svgRef={ref} {...props} />);
export default ForwardRef;



// WEBPACK FOOTER //
// ./src/common/icons/UserAdd.js